import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BaseService} from './base.service';
import {User} from '../modules/admin/models/user';
import {Subject} from 'rxjs';
import {Customer} from "../modules/web/models/CustomerInfo/Customer";



@Injectable({
    providedIn: 'root'
})
export class AuthService extends BaseService {

    private UserLoggedInEventEmitter = new Subject<Customer>();
    private UserLoggedOutEventEmitter = new Subject<any>();


    public UserLoggedInEvent$ = this.UserLoggedInEventEmitter.asObservable();
    public UserLoggedOutEvent$ = this.UserLoggedOutEventEmitter.asObservable();

    private token = '';
    private headers;
    httpOptions: any;
    public isLogged: boolean = false;

    constructor(private httpClient: HttpClient) {

        super();
        this.httpOptions = this.getHttpOptions();
    }


    public authenticate(username: string, password: string) {


        password = encodeURI(password);
        const params = new HttpParams()
            // .set('grant_type', 'password')
            // .set('client_id', '1')
            .set('apiKey', '3TEnWGAVs9If64ZhNVKAqTQ8URF95iJKCQ4gRm1H')
            .set('username', username)
            .set('password', encodeURIComponent(password));

        // return this.httpClient.post<any>(`${this.apiURL}/oauth/token`, params);
        return this.httpClient.post<any>(`${this.apiURL}/users/auth`, params
        );

    }

    public customerAuthentication(username: string, password: string) {


        let serviceUrl = this.baseCatalogUrl + "rest/V1/integration/customer/token";
        const params = {
            username: username,
            password: password
        }

        // return this.httpClient.post<any>(`${this.apiURL}/oauth/token`, params);
        return this.httpClient.post<string>(serviceUrl, params, this.getHttpHeaders());

    }

    public setToken(token: string) {

        this.token = token;
        this.isLogged = true;
        localStorage.setItem('t', token);
    }

    public getToken() {

        if (this.token === '') {
            return localStorage.getItem('t');
        } else {
            return this.token;
        }

    }


    public getHttpHeaders() {




        let ct = localStorage.getItem('customer_type');
        let token = localStorage.getItem('t');

        if (ct != "" && token != "") {
            //push the authorization header
            this.headers = new HttpHeaders({
                'Accept': 'application/json, text/plain, */*',
                'Authorization':' Bearer ' + token
            });

        }else{
            this.headers = new HttpHeaders({
                'Accept': 'application/json, text/plain, */*'
            });
        }

        return this.headers;

    }

    public getHttpOptions() {

        let headers = this.getHttpHeaders()

        let options = {
            'headers': headers
        }
        return options;

    }


    // get user by token

    public getCurrentUser() {

        this.httpOptions = this.getHttpOptions();
        return this.httpClient.get<User>(`${this.apiURL}/user/me`, {headers: this.httpOptions});

    }


    public isAuthenticated() {

        const t = this.getToken();

        if (t === '' || t == null || t === 'null') {
            return false;
        }

        return true;
    }


    /************Events Init****************/
    EmitUserLoggedIn(customer: Customer) {
        this.UserLoggedInEventEmitter.next(customer);
    }

    EmitUserLoggedOut() {
        this.UserLoggedOutEventEmitter.next();
    }

}
